import { render, staticRenderFns } from "./ReportNotFound.vue?vue&type=template&id=80fe5ce8&scoped=true&"
import script from "./ReportNotFound.vue?vue&type=script&lang=js&"
export * from "./ReportNotFound.vue?vue&type=script&lang=js&"
import style0 from "./ReportNotFound.vue?vue&type=style&index=0&id=80fe5ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fe5ce8",
  null
  
)

export default component.exports